import { useState, useEffect, useRef, useContext} from "react";
// import { FaRegBell } from "react-icons/fa";
import { BiChevronDown } from "react-icons/bi";
import menuBarLight from '../../assets/icons/MenubarIcon.svg'
import menuBarDark from '../../assets/icons/lightMenubarIcon.svg';
import cyberBayDark from "../../assets/img/CyberBayFinalBlueLogo.png";
import cyberBayWhite from "../../assets/img/CyberBayWhite.png";
import ProfileImage from "../../assets/img/ProfileImage.svg";
import userProfileIcon from "../../assets/icons/UserProfileIcon.svg";
import LogoutIcon from "../../assets/icons/LogoutIcon.svg";
import ThemesIcon from "../../assets/icons/ThemesIcon.svg";
import TevelDark from "../../assets/img/TevelCyberFinalBlueLogo.png";
import TevelWhite from "../../assets/img/TevelCyberFinalWhiteLogo.png";
import VanaraDark from "../../assets/img/Vaanaraa-Final 2.png";
import VanaraWhite from "../../assets/img/Vaanaraa-FinalWhite.png";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../theme/ThemeContext";
import AuthContext from "../../auth/AuthContext";
import { ImHourGlass } from "react-icons/im";
// import CourseService from "../../services/CourseService";
import { useLocation } from "react-router-dom";


export const Navbar = ({
  isDesktop,showIdleWarning,
  idleStage,
  setSidebarOpen,
  isLabRunning,      
  remainingSeconds ,      
  shouldHideSidebar,
    warningSeconds, 
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [themeSubmenuOpen, setThemeSubmenuOpen] = useState(false);
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  // const [hasClientLogo, setHasClientLogo] = useState(false);
  // const [clientLogo, setClientLogo] = useState();
  const searchInputRef = useRef(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { theme, changeTheme } = useContext(ThemeContext);
  const authContext = useContext(AuthContext);
  const location = useLocation();
  const isBayPage = location.pathname.startsWith("/bay");
  

  const themes = [
    { label: "☀️ Light", value: "light" },
    { label: "🌙 Dark", value: "dark" },
  ];
  const formatMMSS = (totalSeconds) => {
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;

  return (
    String(m).padStart(2, "0") + ":" +
    String(s).padStart(2, "0") + "."
  );
};

  const formatHHMMSS = (totalSeconds) => {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;

  return (
    String(h).padStart(2, "0") + ":" +
    String(m).padStart(2, "0") + ":" +
    String(s).padStart(2, "0")
  );
};

const isLowTime = remainingSeconds <= 300;
  const getAsset = (lightAsset, darkAsset) => {
    return theme === "dark" ? darkAsset : lightAsset;
  };
  const getLogo = () => {
    return getAsset(cyberBayDark, cyberBayWhite);
  };
  const getTevelLogo = () => {
    return getAsset(TevelDark, TevelWhite);
  };
  const getMenuBarIcon = () => {
    return getAsset(menuBarLight, menuBarDark);
  };
  const getVanaraLogo = () => {
  return getAsset(VanaraDark, VanaraWhite);
};

  // const getSearchIcon = () => {
  //   return getAsset(searchIconLight, searchIconDark);
  // };

  useEffect(() => {
    if (isSearchExpanded && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isSearchExpanded]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
        setThemeSubmenuOpen(false);
      }
      if (isSearchExpanded &&
        !e.target.closest('.search-container') &&
        !e.target.closest('.search-icon')) {
        setIsSearchExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isSearchExpanded]);

  // const loadClients = useCallback(async () => {
  //   setHasClientLogo(false);
  //   var result = await CourseService.GetClients(authContext);
  //   if (result.isSuccess && result.data.length) {
  //     setHasClientLogo(true);
  //     setClientLogo(result.data[0].clientLogo);
  //   }
  // }, [authContext])

  // useEffect(() => {
  //   loadClients();
  // }, [loadClients]);

  return isDesktop ? (
    <>
      <div
        className="d-flex align-items-center px-4 px-lg-3 navbar justify-content-between shadow"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          flexShrink: 0,
          height: "80px",
        }}
      >
        <div
          className={`d-flex gap-4 align-items-center ${!shouldHideSidebar ? "justify-content-between" : "justify-content-center"
            }`}
        >
           <div>
            <img
              src={getTevelLogo()}
              alt="Tevel Logo"
              onClick={() => navigate('/')}
              style={{
                maxWidth: "120px",
                height: "auto",
                cursor: 'pointer'
              }}
            />
          </div>
          {/* {!shouldHideSidebar && (<div>
            <img
              src={getMenuBarIcon()}
              alt="menu"
              style={{ cursor: "pointer", minWidth: "37px" }}
              onClick={() => {
                if (isDesktop) {
                  if (!hasFilter) {
                    setIsSidebarCollapsed(prev => !prev);
                  } else {
                    setSidebarOpen(prev => !prev);
                  }
                } else {
                  setSidebarOpen(true);
                }
              }}
            />
          </div>
          )} */}
       
        
         
        </div>

        <div className="d-flex align-items-center gap-4">
{isLabRunning && remainingSeconds > 0 && !isBayPage && (
  <div className="d-flex align-items-center gap-3">

    {/* Small Warning Badge */}
    {showIdleWarning && idleStage === "warning" && (
      <div
        className="d-flex align-items-center gap-2"
        style={{
          backgroundColor: "#fdecea",
          color: "#d32f2f",
          padding: "6px 12px",
          borderRadius: "20px",
          fontSize: "0.9rem",
          fontWeight: 500,
          whiteSpace: "nowrap"
        }}
      >
        <span style={{ fontSize: "0.9rem" }}>⚠</span>
        Lab session is inactive. It will automatically shut down in <strong>{formatMMSS(warningSeconds)}</strong> Please return to the lab to continue.
      </div>
    )}

    {/* Lab Time Pill */}
    <div
      className="d-flex align-items-center justify-content-center gap-2"
      style={{
        backgroundColor: isLowTime ? "#dc3545" : "#0D3744",
        color: "#fff",
        padding: "6px 16px",
        borderRadius: "999px",
        fontWeight: "500",
        fontSize: "0.85rem",
        minWidth: "120px",
        height: "36px",
        whiteSpace: "nowrap",
      }}
    >
      <ImHourGlass style={{ fontSize: "0.9rem" }} />
      <span>Lab Time</span>
      <span style={{ fontWeight: 600 }}>
        {formatHHMMSS(remainingSeconds)}
      </span>
    </div>

  </div>
)}
           <div>
       <img
  src={getVanaraLogo()}
  alt="Vanara Logo"
  style={{
    maxWidth: "150px",
    height: "auto",
  }}
/>
          </div>
          <div>
            <img
              src={getLogo()}
              alt="CyberBay Logo"
              style={{
                maxWidth: "62px",
                height: "auto",
              }}
            />
          </div>
              {/* <div>
            {hasClientLogo && <img
              src={clientLogo}
              alt="Client Logo"
              style={{
                maxWidth: "100px",
                height: "auto",
              }}
            />}
          </div> */}


          {/* <div className="d-flex align-items-center me-5">
          {!isSearchExpanded && (
            <div className="search-icon" style={{ cursor: "pointer" }}>
              <img src={getSearchIcon()} alt="Search" style={{ height: "30px" }} onClick={() => setIsSearchExpanded(true)} />
            </div>
          )}
          {isSearchExpanded && (
            <div className="position-relative" style={{ width: "200px" }}>
              <input
                ref={searchInputRef}
                type="text"
                className="form-control pe-5 rounded py-2"
                placeholder="Search..."
                style={{ transition: "width 0.4s ease" }}
              />
              <BiSearch
                className="position-absolute top-50 end-0 translate-middle-y me-2"
              />
            </div>
          )}
        </div> */}

          <div className="d-flex align-items-center gap-5" ref={dropdownRef}>

            {/* Bell Icon */}
            {/* <div className="position-relative">
            <FaRegBell style={{ fontSize: "2.0rem", maxWidth: "30px" }} />
            <span
              className="icons position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"
              style={{ width: 8, height: 8, transform: "translate(-75%, 35%)" }}
            ></span>
          </div> */}


            {/* Profile + Dropdown */}
            <div className="position-relative">
              <div
                className="d-flex align-items-center gap-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setDropdownOpen(!dropdownOpen);
                  setThemeSubmenuOpen(false);
                }}
              >
                <div
                  className="rounded-circle overflow-hidden d-flex justify-content-center align-items-center"
                  style={{ width: "30px", height: "30px", backgroundColor: "#0D3744" }}
                >
                  <img
                    src={ProfileImage}
                    alt="Profile"
                    style={{ width: "30px", height: "30px", objectFit: "cover" }}
                  />
                </div>
                <p className="fw-bold mb-0">{authContext.displayName}</p>
                <BiChevronDown
                  className={`transition ${dropdownOpen ? "rotate-180" : ""}`}
                  style={{ fontSize: "1.2rem" }}
                />
              </div>

              {dropdownOpen && (
                <div
                  className="position-absolute end-0 mt-2 p-2 shadow rounded dropdown mt-3 p-3"
                  style={{ width: 260, zIndex: 999 }}
                >
                  <ul className="list-unstyled mb-0">
                    <li
                      className="p-2 ps-3 mb-2 d-flex align-items-center  "
                      onClick={() => navigate("/profile")}
                      style={{ cursor: "pointer" }}
                    >
                      <img src={userProfileIcon} alt="Profile" className="me-3"></img>
                      Profile
                    </li>

                    {/* Themes with Expandable List */}
                    <li
                      className="p-2 ps-3 mb-1 d-flex justify-content-start align-items-center"
                      style={{ cursor: "pointer" }}
                      onClick={() => setThemeSubmenuOpen(!themeSubmenuOpen)}
                    >
                      <img src={ThemesIcon} alt="Themes" className="me-3 mt-2 mb-2" />Themes
                      <BiChevronDown
                        className={` ms-5 transition ${themeSubmenuOpen ? "rotate-180" : ""}`}
                        style={{ fontSize: "1.2rem" }}
                      />
                    </li>

                    {themeSubmenuOpen && (
                      <ul className="list-unstyled px-2 pb-2">
                        {themes.map((t) => (
                          <li
                            key={t.value}
                            className="py-2 ps-3" 
                            style={{
                              cursor: "pointer",
                              backgroundColor:
                                theme === t.value
                                  ? theme === "dark"
                                    ? "#333"
                                    : "#f1f1f1"
                                  : "transparent",
                              borderRadius: "4px",
                              paddingTop: "10px",
                              paddingBottom: "10px",
                            }}
                            onClick={() => {
                              changeTheme(t.value);
                              setThemeSubmenuOpen(false);
                            }}
                          >
                            <span style={{ marginRight: "10px" }}>{t.label.split(" ")[0]}</span>
                            <span>{t.label.split(" ")[1]}</span>
                          </li>
                        ))}

                      </ul>

                    )}
                    <li className="p-2 ps-3 text-danger mt-2" onClick={() => navigate("/logout")} style={{ cursor: "pointer" }}>
                      <img src={LogoutIcon} alt="Logout" className="me-3 mb-1" />Logout
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
  <div
  className="d-flex align-items-center px-4 px-lg-3 py-3 navbar justify-content-between shadow"
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1100,
    flexShrink: 0,
    height: "68px",
  }}
>
  <div className="d-flex align-items-center gap-3">
  {!shouldHideSidebar && (
    <div>
      <button className="btn p-0" onClick={() => setSidebarOpen(true)}>
        <img src={getMenuBarIcon()} alt="menu" />
      </button>
    </div>
  )}

  {/* Logo Section */}
  
    <img
      src={getTevelLogo()}
      alt="Tevel Logo"
      onClick={() => navigate('/')}
      style={{
        maxWidth: "100px",
        height: "auto",
        cursor: "pointer"
      }}
    />
    <img
      src={getLogo()}
      alt="CyberBay Logo"
      onClick={() => navigate('/')}
      style={{
        maxWidth: "60px",
        height: "auto",
        cursor: "pointer"
      }}
    />
  </div>

  {/* User/Profile/Dropdown Section */}
  <div className="d-flex align-items-center gap-3">
    <div className="d-flex align-items-center gap-3" ref={dropdownRef}>
      <div className="position-relative">
        <div
          className="d-flex align-items-center gap-2"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setDropdownOpen(!dropdownOpen);
            setThemeSubmenuOpen(false);
          }}
        >
          <div
            className="rounded-circle overflow-hidden d-flex justify-content-center align-items-center"
            style={{
              width: "30px",
              height: "30px",
              backgroundColor: "#0D3744",
            }}
          >
            <img
              src={ProfileImage}
              alt="Profile"
              style={{ width: "30px", height: "30px", objectFit: "cover" }}
            />
          </div>
          {/* <p className="fw-bold mb-0" style={{fontSize:'0.6rem'}}>{authContext.displayName}</p> */}
          <BiChevronDown
            className={`transition ${dropdownOpen ? "rotate-180" : ""}`}
            style={{ fontSize: "1.2rem" }}
          />
        </div>

        {dropdownOpen && (
          <div
            className="position-absolute end-0 mt-2 shadow rounded dropdown"
            style={{ width: 200, zIndex: 999 }}
          >
            <ul className="list-unstyled mb-0 p-3">
              <li
                className="p-2 ps-3 mb-2 d-flex align-items-center"
                onClick={() => navigate("/profile")}
                style={{ cursor: "pointer" }}
              >
                <img src={userProfileIcon} alt="Profile" className="me-3" />
                Profile
              </li>
              <li
                className="p-2 ps-3 mb-1 d-flex align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => setThemeSubmenuOpen(!themeSubmenuOpen)}
              >
                <img src={ThemesIcon} alt="Themes" className="me-3 mt-2 mb-2" />
                Themes
                <BiChevronDown
                  className={`ms-5 transition ${themeSubmenuOpen ? "rotate-180" : ""}`}
                  style={{ fontSize: "1.2rem" }}
                />
              </li>
              {themeSubmenuOpen && (
                <ul className="list-unstyled px-2 pb-2">
                  {themes.map((t) => (
                    <li
                      key={t.value}
                      className="py-2 ps-3"
                      style={{
                        cursor: "pointer",
                        backgroundColor:
                          theme === t.value
                            ? theme === "dark"
                              ? "#333"
                              : "#f1f1f1"
                            : "transparent",
                        borderRadius: "4px",
                      }}
                      onClick={() => {
                        changeTheme(t.value);
                        setThemeSubmenuOpen(false);
                      }}
                    >
                      <span style={{ marginRight: "10px" }}>
                        {t.label.split(" ")[0]}
                      </span>
                      <span>{t.label.split(" ")[1]}</span>
                    </li>
                  ))}
                </ul>
              )}
              <li
                className="p-2 ps-3 text-danger mt-2"
                onClick={() => navigate("/logout")}
                style={{ cursor: "pointer" }}
              >
                <img src={LogoutIcon} alt="Logout" className="me-3 mb-1" />
                Logout
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  </div>
</div>

  );
};